import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from '../Navbar.js';
import { ChevronRightIcon } from '@heroicons/react/16/solid';
import BackHeaderTop from "../components/BackHeaderTop";

function HeaderPost(args) {

  return (
    <>
      <div className="relative">
      <BackHeaderTop/>
      <Navbar user={args.user}/>
        <div className="container text-center">
          
          <div className="px-6 py-8">
            <div className="mx-auto">
              <nav aria-label="Breadcrumb" className="flex justify-center">
                <ol role="list" className="flex items-center space-x-4 p-0 flex-wrap">
                  <li>
                    <div>
                      <Link to="/" className="text-gray-400 hover:text-gray-500">
                        Clotere
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="flex items-center">
                      <ChevronRightIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />
                      <Link
                        to={args.breadlink1}
                        className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                      >
                        {args.namelink1}
                      </Link>
                    </div>
                  </li>
                  <li>
                    <div className="flex items-center">
                      <ChevronRightIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />
                      <Link
                        to={args.breadlinkActive}
                        className="ml-4 text-sm font-medium text-indigo-800 hover:text-gray-700"
                      >
                        {args.namelinkActive}
                      </Link>
                    </div>
                  </li>
                </ol>
              </nav>
              <h1 className="mt-2 text-4xl font-bold text-gray-900 sm:text-5xl sm:max-w-[80%] mx-auto">
                {args.titre}
              </h1>
              <div className="flex flex-row gap-3 align-center justify-center">
              <div className="relative mt-8 flex items-center gap-x-4">
                <img alt="Cecile Clotere" src={"https://cdn.prod.website-files.com/6511aea2595791e5183ad06c/6512a7dedc0599868e9cf144_IMG-20220121-WA0010~2.jpg"} className="size-10 rounded-full bg-gray-50" />
                <div className="text-sm/6 text-left">
                  <p className="font-semibold text-gray-900 mb-0">
                      <span className="absolute inset-0" />
                      Cécile
                  </p>
                  <p className="text-gray-600 mb-0">Chargée d'affaire Clotere</p>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default HeaderPost;